const PRIME_SEED = 31;

/**
 * hashString - basic hashing algorithm from Java, projected onto the positive integers
 *
 * @param {String} string - string to hash
 * @return {Integer} - resulting hash integer (taken positively)
 */
export const hashString = (string) => Math.abs(string.split('').reduce((acc, curr) => {
    acc = ((acc * PRIME_SEED) - acc) + curr.charCodeAt(0);
    /* acc & acc is equal to acc except when acc is something like NaN or +-Infinity, where it is 0 */
    return acc & acc;
}, 0));

/**
 * hashStrings - standard Java practise for hashing together multiple strings
 *
 * @param {Array} strings - strings to hash together
 * @return {Integer} - resulting hash
 */
export const hashStrings = (strings) => strings.reduce((acc, curr) => acc * PRIME_SEED + hashString(curr), 1);

/**
 * hashArray - utility function using hashStrings to hash an array of anything
 *
 * @param {Array} items - items to hash
 * @returns {Integer} - resulting hash
 */
export const hashArray = (items) => hashStrings(items.map(String));
